import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { SalesCourse } from '~/types';

import { TeacherBio, TabTitle } from './elements';

export const TeachersTab = ({ teachers }: { teachers: SalesCourse['teachers'] }) => (
  <>
    {teachers.map((teacher, idx) => (
      <Box my={5}>
        <Grid container direction={idx % 2 === 0 ? 'row' : 'row-reverse'}>
          <Grid item xs={12} md={4}>
            <Avatar
              style={{ height: 200, width: 200, margin: 'auto' }}
              src={teacher.image.processed_url}
            />
            <TabTitle>{teacher.full_name}</TabTitle>
          </Grid>
          <Grid item xs={12} md={8}>
            <TeacherBio dangerouslySetInnerHTML={{ __html: teacher.about_me || '' }} />
          </Grid>
        </Grid>
      </Box>
    ))}
  </>
);
